<template>
  <div v-if="content || unavailable">
    <!-- 首頁／分類頁、活動頁、VIP 頁的可見 SEO 正文（僅 theme_gold）；文案只有日文，標 lang 讓其他語系下仍以日文字體與斷詞呈現 -->
    <section v-if="content" class="category-seo-content" lang="ja">
      <h1>{{ content.h1 }}</h1>
      <div
        v-for="(section, index) in content.sections"
        :key="index"
        class="category-seo-section"
      >
        <h2>{{ section.h2 }}</h2>
        <p>{{ section.p }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import { getCategorySeoContent, getPageSeoContent } from '@/config/categorySeoContent'

export default {
  name: 'CategorySeoContent',
  props: {
    seoPath: {
      type: String,
      default: ''
    },
    // 獨立頁面（'event'、'vip'）；有值時不看 seoPath
    page: {
      type: String,
      default: ''
    },
    // 頁面資料無法載入時顯示佔位提示；呼叫端只在 theme_gold 掛載本元件
    unavailable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    content() {
      return this.page ? getPageSeoContent(this.page) : getCategorySeoContent(this.seoPath)
    }
  }
}
</script>

<style scoped>
.seo-data-unavailable {
  margin: 24px 0 0;
  padding: 32px 16px;
  border: 1px dashed var(--ui-border-subtle);
  border-radius: 8px;
  color: var(--ui-text-muted);
  text-align: center;
}

.category-seo-content {
  margin: 40px 0 24px;
  padding-top: 24px;
  border-top: 1px solid var(--ui-border-subtle);
  color: var(--ui-text-muted);
  line-height: 1.8;
}

.category-seo-content h1 {
  margin: 0 0 20px;
  color: var(--ui-text);
  font-size: 20px;
  line-height: 1.5;
}

.category-seo-section + .category-seo-section {
  margin-top: 20px;
}

.category-seo-content h2 {
  color: var(--ui-text);
  font-size: 16px;
  line-height: 1.5;
}

.category-seo-content p {
  margin: 0;
  font-size: 14px;
}
</style>
